export * from './ArchiveBoxOpenDocsIcon';
export * from './ArchiveBoxOpenDocsIcon16Light';
export * from './ArchiveBoxOpenDocsIcon16Regular';
export * from './ArchiveBoxOpenDocsIcon16Solid';
export * from './ArchiveBoxOpenDocsIcon20Light';
export * from './ArchiveBoxOpenDocsIcon20Regular';
export * from './ArchiveBoxOpenDocsIcon20Solid';
export * from './ArchiveBoxOpenDocsIcon24Regular';
export * from './ArchiveBoxOpenDocsIcon24Solid';
export * from './ArchiveBoxOpenDocsIcon32Regular';
export * from './ArchiveBoxOpenDocsIcon64Regular';
